import $ from 'jquery';

export function initWaitingNotice() {
  const $elem = $('.waiting-notice');
  const $text = $('.waiting-notice__text');

  if ($elem.length === 0) {
    console.error("Didn't find a element of .waiting-notice");
  }

  return {
    show,
    hide,
    text,
    resetOffset,
    bottomOffset,
  };

  function text(html) {
    $text.html(html);
  }

  function show() {
    $elem.show();
  }

  function hide() {
    $elem.hide();
  }

  function resetOffset() {
    $elem.css('bottom', 0);
  }

  function bottomOffset(value) {
    $elem.css('bottom', value);
  }
}
